import {useQueryClient} from '@tanstack/react-query';
import {useEffect} from 'react';

type UseRemoveCacheAfterUnmountParam<Variables> = {
  shouldRemoveCacheAfterUnmount?: boolean;
} & {
  variables: Variables;
  // @deprecated: ReactQueryFetcher 마이그레이션 완료시 아래 props는 제거 해야합니다.
  getKey?: (variables: Variables) => string[];
  keys?: string[][];
};

/**
 * 언마운트 후에 캐시를 비울 수 있는 hook입니다
 * 특정 쿼리를 구독중이지 않지만(inactive) 컴포넌트가 마운트 된 상황에는 캐싱을 유지하고,
 * 언마운트 될 때는 캐시 타임이 남아 있더라도 바로 제거하고 싶을 때 사용할 수 있는 hook입니다. (검색 자동완성 스펙)
 */
export function useRemoveCacheAfterUnmount<Variables>({
  shouldRemoveCacheAfterUnmount,
  variables,
  getKey,
  keys,
}: UseRemoveCacheAfterUnmountParam<Variables>) {
  const queryClient = useQueryClient();
  useEffect(() => {
    return () => {
      if (shouldRemoveCacheAfterUnmount) {
        // XXX(@harry): variables의 optional/required를 구분하기 힘들어 타입 분기가 해결되지 않네요. 내부에서만 사용될 코드이니 임시로 ignore합니다.
        // @ts-ignore
        if (getKey) {
          const operationKey = getKey(variables)[0];
          queryClient.removeQueries({queryKey: [operationKey]});
        }

        if (keys) {
          keys.forEach(key => queryClient.removeQueries({queryKey: key}));
        }
      }
    };
  }, [getKey, queryClient, shouldRemoveCacheAfterUnmount, variables, keys]);
}
